import axios from 'axios';
import store from '~/store';
import constants from 'Helpers/constants';
import utils from 'Helpers/utils';
import { eventBus } from '../../../app';

const mixinActions = (pageCode) => {
    return {
        async list(context, params) {
            let start = (params.options.page - 1) * (params.options.itemsPerPage ? params.options.itemsPerPage : 0);
            let sort = [];
            let filters = {};

            params.options.sortBy.forEach(function (val, idx) {
                sort.push({
                    property: val,
                    direction: params.options.sortDesc[idx] ? 'ASC' : 'DESC',
                });
            });

            if (params.filters) {
                Object.keys(params.filters).map(function (objectKey) {
                    var value = params.filters[objectKey];
                    if (value !== '' && value !== null) {
                        filters[objectKey] = value;
                    }
                });
            }

            let paramsData = {
                requiredDictionaries: params.requiredDictionaries,
                requiredData: params.requiredData,
                page: params.options.page,
                filter: filters,
                start: start,
                limit: params.options.itemsPerPage,
                sort: JSON.stringify(sort),
            };

            if (store.state.AppModule.isInitialized === false) {
                paramsData.init = true;
            }

            if (params.extraParams) {
                paramsData = Object.assign(paramsData, params.extraParams);
            }

            let pageUrl = window.location.toString();

            //Guest access to FeedLive/Dball pages allowed only for guest users from WL platforms
            if (utils.getPlatform() !== constants.PLATFORM_TRADEBALL) {
                let user = store.getters['UserModule/getUser'];
                if (user.type === constants.USER_TYPE_GUEST_ID && (pageCode === 'feedLive' || pageCode === 'feedDball')) {
                    pageCode = pageCode + 'Guest';
                }
            }

            return await axios
                .get('/api/' + pageCode + '/list', {
                    params: paramsData,
                })
                .then((response) => {
                    if (response.data.config && response.data.config.scriptVersion) {
                        if (!localStorage.getItem('scriptVersion')) {
                            localStorage.setItem('scriptVersion', response.data.config.scriptVersion);
                        } else if (localStorage.getItem('scriptVersion') != response.data.config.scriptVersion) {
                            localStorage.setItem('scriptVersion', response.data.config.scriptVersion);
                            utils.reload();
                        }
                    }

                    //if pageUrl is changed, no need to send updateUserData, player can change page during load data
                    if ('updateUserData' in params && params.updateUserData === true && pageUrl === window.location.toString()) {
                        //we moved updateUserData from router.js due to need to add filters
                        let data = {
                            pageUrl: pageUrl,
                            pageCode: pageCode,
                        };

                        if (!_.isEmpty(filters)) {
                            data['filter'] = filters;
                        }

                        //need to store it, we will resend it if websocket is reconnected
                        store.state.WebSocketModule.userData = data;

                        store.dispatch('sendObj', {
                            event: 'updateUserData',
                            data: data,
                        });
                    } /* else {
                        console.log(
                            'updateUserData was not sent because router controller name is %s, but request URL is %s',
                            router.currentRoute.meta.backendController.toLowerCase(),
                            url.toLowerCase()
                        );
                    }*/

                    if (response.data.success !== false) {
                        if (response.data.config && !_.isEmpty(response.data.config)) {
                            context.commit('AppModule/setConfig', response.data.config, { root: true });
                        }

                        if (response.data.balance && !_.isEmpty(response.data.balance)) {
                            context.commit('UserModule/setBalance', response.data.balance, { root: true });
                        }

                        if (response.data.notification && !_.isEmpty(response.data.notification)) {
                            eventBus.$emit('updateNotifications', response.data.notification);
                        }

                        if (response.data.dictionary) {
                            //depends on requiredDictionaries[]
                            context.dispatch('DictionariesModule/setDictionaries', response.data.dictionary, {
                                root: true,
                            });
                        }

                        store.state.AppModule.isInitialized = true;

                        context.commit('setResponse', {
                            response: response.data,
                        });

                        if (params.beforeListLoad instanceof Function) {
                            params.beforeListLoad(response);
                        }
                        //we need fav events/leagues/teams on all pages
                        if ('favoriteEvents' in response.data) {
                            context.commit('AppModule/setFavoriteEvent', response.data.favoriteEvents, { root: true });
                        }

                        if ('favoriteLeagues' in response.data) {
                            context.commit('LeagueModule/setFavoriteLeague', response.data.favoriteLeagues, {
                                root: true,
                            });
                        }

                        if ('favoriteTeams' in response.data) {
                            context.commit('TeamModule/setFavoriteTeam', response.data.favoriteTeams, { root: true });
                        }

                        if ('bets' in response.data) {
                            context.commit('AppModule/setBets', response.data.bets, { root: true });
                        }

                        if ('orders' in response.data) {
                            context.commit('AppModule/setOrders', response.data.orders, { root: true });
                        }

                        if ('botStats' in response.data) {
                            context.commit('BotModule/setStats', response.data.botStats, { root: true });
                        }

                        if (response.data.rows) {
                            context.commit('setList', response.data.rows);
                        }
                        context.commit('PageModule/setTotal', response.data.total, { root: true });

                        if (response.data.stats) {
                            //depends on requiredData['Stats']
                            context.commit('setStats', response.data.stats);
                        }
                    }

                    return Promise.resolve(response);
                })
                .catch(() => {
                    context.commit('PageModule/setLoading', false, { root: true });
                });
        },
        create(context, params) {
            return axios.post('/api/' + pageCode + '/create', params).then((response) => {
                if (response.data.success) {
                    context.dispatch('afterCreated', response.data);
                }
                return Promise.resolve(response);
            });
        },
        update(context, params) {
            return axios.post('/api/' + pageCode + '/update', params).then((response) => {
                return Promise.resolve(response);
            });
        },
        delete(context, item) {
            return axios
                .post('/api/' + pageCode + '/delete', {
                    rows: [item],
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },
    };
};

export default mixinActions;
